import "reset-css";
import "swiper/css";
import "./scss/index.scss";
import "./mock/mockAdapter"; // Import the mock adapter setup
import "@fortawesome/fontawesome-free/css/all.min.css";

import { persistor, store } from "./store/index";

import { AppProvider } from "./contexts/AppContext";
import { BottomSheet } from "./components/modals/BottomSheet";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { StackNavigator } from "./navigation/StackNavigator";

import Authentication from "./auth/Authentication"

function App() {
  return (
    <div id="app">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppProvider>
            <Authentication>
              <BottomSheet />
              <StackNavigator />
            </Authentication>
          </AppProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
